import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.workOrder

//企业证书列表
export function getQualifyProveList(data) {
  return request({
    url: serviceName + '/qualify/page',
    method: 'post',
    data
  })
}
//新增企业证书
export function postQualifyProve(data) {
  return request({
    url: serviceName + '/qualify/submit',
    method: 'post',
    data
  })
}

//删除企业证书
export function deleteQualifyProve(data) {
  return request({
    url: serviceName + `/qualify/removeById?id=${data}`,
    method: 'get',
  })
}

//下载企业证书
export function downloadQualifyProve(data) {
  return request({
    url: serviceName + `/file-manage/download?fileId=${data}`,
    method: 'get',
    responseType: 'blob'
  })
}